import BlogSubscribeBox from "./BlogSubscribeBox";

export default BlogSubscribeBox;
